<template>
  <div class="row">
    <div v-if="user" class="col-12">
      <Heading>
        {{ user.name || user.username }}
      </Heading>
      <div class="border border-light p-5">

        <div class="row">

          <div class="col-4">
            <b class="text-primary">Username:</b><br>
            <data-input v-model="user.username"/>
            <b class="text-primary">Passwort:</b><br>
            <data-input type="password" @input="addPassword"/>
          </div>
          <div class="col-4">
            <b class="text-primary">Rolle:</b><br>
            <data-select :options="['admin', 'manager', 'driver']" v-model="user.role"/>
          </div>
          <div class="col-4">
            <b class="text-primary">Status:</b><br>
            <data-select :options="['Aktiv', 'Inaktiv']" :value="user.active?'Aktiv':'Inaktiv'"
                         @input="setActiveState"/>
          </div>
          <div class="col-3 offset-6 text-right">
            <button @click="cancel" class="btn btn-secondary btn-block mt-5 btn-sm">Abbrechen</button>
          </div>
          <div class="col-3 text-right">
            <button @click="save" class="btn btn-primary btn-block mt-5 btn-sm">Speichern</button>
          </div>
        </div>
      </div>
      <list v-if="user.bottles > 0" :items="user.bottles" class="mt-5">
        <template v-slot:header>
          <div class="row">
            <div class="col-4">Flaschen Nummer</div>
            <div class="col-4">Typ</div>
            <div class="col-3">Fällig am</div>
          </div>
        </template>
        <template v-slot:itemTemplate="{item}">
          <div class="row align-items-center py-1">
            <!--						 <div class="col-12">{{item}}</div>-->
            <div class="col-4">
              Nr. {{ item.serial }}
            </div>
            <div class="col-4">
              {{ item.type }}
            </div>
            <div class="col-3">
              {{ dateWithFormat(item.due) }}
            </div>
            <div class="col-1">
              <button class="btn" @click="$router.push('/admin/bottles/'+item.id)">
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </template>
      </list>
    </div>
  </div>
</template>

<script>
import Heading from "../../components/admin/Heading";
import {mapActions} from "vuex";
import BottleState from "../../components/admin/BottleState";
import List from "../../components/admin/List";
import timeFormatter from "../../mixins/timeFormatter";
import DataSelect from "../../components/DataSelect";
import DataInput from "../../components/DataInput";

export default {
  name: "UserAdd",
  components: {DataInput, DataSelect, Heading, BottleState, List},
  mixins: [timeFormatter],
  data() {
    return {
      user: {
        username: "",
        role: "",
        active: true,
        password: ""
      }
    }
  },
  methods: {
    ...mapActions({
      addUser: "Api/Users/add"
    }),
    setActiveState(state) {
      this.user.active = (state === 'Aktiv')
    },
    addPassword(e) {
      this.user.password = e
    },
    save() {
      this.addUser(this.user)
          .then(() => this.$router.back())
          .catch(this.apiErrorHandler)
    },
    cancel() {
      this.$router.back()
    }
  }
}
</script>
